import React from "react";
import { ModalLicenseAgreementContext } from "./modal-license-agreement-context";
import { useModalLicenseAgreementHook } from "./modal-license-agreement-hooks";
import { ModalLicenseAgreementProps } from "../types/index";

export function ContextModalLicenseAgreementProvider({
  children,
}: {
  children: React.ReactNode;
} & ModalLicenseAgreementProps) {
  const value = useModalLicenseAgreementHook();

  return (
    <ModalLicenseAgreementContext.Provider value={value}>
      {children}
    </ModalLicenseAgreementContext.Provider>
  );
}
